const state = {
    profileId: null,
    phone: null,
    subscriptionEndDate: null,
    isRequesting: false,
    hintsEnabled: null,
}
export default state
